"use client";

import type { ReactElement } from "react";
import { SRC } from "../developers/_components/developers-funnel-content";
import { FunnelImage } from "../developers/_components/developers-funnel-image";
import { CAREERS_BENEFITS_TITLE } from "./careers-benefits-copy";
import { CareersBenefitsGrid } from "./careers-benefits-section";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";

/** One offer band: office photo, then the benefit list. No second copy of
 * home office / hours / Worms — hero chips tease, this list is the source. */
export function CareersLocationSection(): ReactElement {
  const { lang } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].location;

  return (
    <section id="benefits" className="dvf-section c2-center">
      <div className="dvf-section-inner">
        <h2 className="dvf-section-title">{CAREERS_BENEFITS_TITLE[lang]}</h2>
        <FunnelImage
          slot={{
            src: SRC.office,
            alt: t.imageAlt,
            title: t.imageTitle,
            hint: "Team / office photo · 1600 × 1000",
            ratio: "16 / 10",
            caption: t.caption,
          }}
          className="c2-ben-photo"
          sizes="(min-width: 768px) 640px, 100vw"
        />
        <CareersBenefitsGrid />
      </div>
    </section>
  );
}
